import { FormControl } from '@chakra-ui/react'
import { Insurer } from 'BrokerTsLib/src/enums'
import { useFormContext } from 'BrokerTsLib/src/rhf'
import { useContext, useEffect } from 'react'

import { Loading } from '../../../components/Loading'
import { useGetInsurersSpecificParams } from '../../../hooks/useInsuranceParams'
import { insuranceParamsContext } from '../../../layouts/Wizard'
import { BaScoringCheckbox } from '../BAScoringCheckbox'
import { IndividualCompany } from '../IndividualCompany'
import {
  IndividualDiscountsGroup,
  IndividualDiscountsWrapper,
} from '../IndividualDiscountsWrapper'

export const IndividualDiscounts = () => {
  const { insuranceParamsId: paramsId, insuranceParams } = useContext(
    insuranceParamsContext,
  )!
  const isContracted = !!insuranceParams?.generalParams.contractNumber

  const { setValue, getValues } = useFormContext()

  const { data, isLoading, isFetching } = useGetInsurersSpecificParams(paramsId!, null)

  useEffect(() => {
    if (data?.data) setValue('individualDiscounts', data.data)
  }, [data])

  const csobIndex = data?.data?.findIndex((x) => x.insurer == Insurer.Csob)
  
  const loading = isLoading || isFetching

  return (
    <IndividualDiscountsWrapper>
      {loading && <Loading large={true} />}

      {!loading && (data?.data ?? []).length > 0 && (
        <>
          <IndividualDiscountsGroup>
            <IndividualCompany id={Insurer.Csob} name="ČSOB Pojišťovna">
              <FormControl>
                <BaScoringCheckbox
                  isContracted={isContracted}
                  name={`individualDiscounts.${csobIndex}.baScoring`}
                />
              </FormControl>

              {/* <LocalInputGroup
              id="contract-other-csob"
              name="contract-other-csob"
              label="Pojistná smlouva u ČSOB Pojištovna"
              tooltip='V případě, že má klient sjednanou jinou pojistnou smlouvu u této pojišťovny, může dát pojišťovna dodatečnou slevu na pojistném.'
              optional
              isDisabled={isContracted}
              placeholder="Číslo pojistné smlouvy"
              defaultValue={getValues(`individualDiscounts.${csobIndex}.contractNumber`) ?? ''}
              onChange={(e: any) => setValue(`individualDiscounts.${csobIndex}.contractNumber`, e.target.value)}
            /> */}
            </IndividualCompany>
          </IndividualDiscountsGroup>
        </>
      )}
    </IndividualDiscountsWrapper>
  )
}
